export const CLARET_REPORTS = [
  {
    id: 'wip',
    name: 'WIP Report',
    description: 'Percent complete, earned revenue, cost, billings, and over/under billing.',
  },
  {
    id: 'project-analysis',
    name: 'Project Analysis',
    description: 'Flags missing change-order fees, fee-rate drift, over/under billing, and costs not on the contract.',
  },
  {
    id: 'journal-entries',
    name: 'Journal Entries',
    description: 'Posted journal entries by period, project, and source transaction.',
  },
  {
    id: 'commitments',
    name: 'Commitments Report',
    description: 'Original amount, change orders, invoiced, and remaining by commitment.',
  },
  {
    id: 'unposted',
    name: 'Unposted Transactions',
    description: 'AP invoices, billings, labor, and expenses not yet posted for a period.',
  },
  {
    id: 'audit',
    name: 'Accounting Audit Report',
    description: 'Posted records with external IDs, sync status, and reconcile status.',
  },
  {
    id: 'procore-sync',
    name: 'Procore Sync Report',
    description: 'Records on Procore-linked projects that have not been sent to Procore, including cost transactions as Direct Costs.',
  },
  {
    id: 'general-ledger',
    name: 'General Ledger Report',
    description: 'Debits and credits by GL account for the selected period.',
  },
];

export function reportPath(projectVuid, reportId) {
  const base = projectVuid ? `/procore/projects/${projectVuid}/reports` : '/procore/reports';
  return reportId ? `${base}/${reportId}` : base;
}
